import { Button } from '@mantine/core';
import { toastNotifications, variants, Modal } from '@uag/react-core';
import { useRemoveTeamMember } from '@uag/welcome-shared/src/api/queries/teams/teams';
import { useTranslation } from 'react-i18next';
import { create, InstanceProps } from 'react-modal-promise';

type DeleteModalProps = {
    title: string;
    acceptButtonText: string;
    memberName: string;
    contributorId: string;
    teamId: string;
} & InstanceProps<void>;

const DeleteModal = ({
    title,
    acceptButtonText,
    memberName,
    contributorId,
    isOpen,
    onResolve,
    teamId,
    onReject,
}: DeleteModalProps) => {
    const { mutateAsync: removeTeamMember, isPending } = useRemoveTeamMember();
    const { t } = useTranslation();

    const submit = async () => {
        try {
            await removeTeamMember({ id: teamId, contributorId });
            onResolve();
        } catch (err) {
            toastNotifications.errorDetail(
                {
                    title: t('unknownError'),
                    message: t('unknownErrorDescription'),
                },
                err,
            );
        }
    };
    const handleReject = () => {
        onReject();
    };

    return (
        <Modal opened={isOpen} title={title} onClose={onReject}>
            <div className="flex w-[560px] flex-col gap-6">
                <div className="flex flex-col items-start gap-2">
                    <span className="leading-base text-text-ultra-light w-full text-base font-normal">
                        {t('removeMemberText', { name: memberName })}
                    </span>
                </div>
                <div className="gap-x-base flex flex-row justify-end">
                    <Button variant={variants.button.secondary} onClick={handleReject}>
                        {t('cancel')}
                    </Button>
                    <Button loading={isPending} variant={variants.button.danger} onClick={submit}>
                        {acceptButtonText}
                    </Button>
                </div>
            </div>
        </Modal>
    );
};

export const openDeleteModal = create(DeleteModal);
